import { render, staticRenderFns } from "./MyFollow.vue?vue&type=template&id=15404195&scoped=true"
import script from "./MyFollow.vue?vue&type=script&lang=js"
export * from "./MyFollow.vue?vue&type=script&lang=js"
import style0 from "./MyFollow.vue?vue&type=style&index=0&id=15404195&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15404195",
  null
  
)

export default component.exports